export default __webpack_public_path__ + "static/media/reset.51731f25.svg";